<div id="buttonContainer" class="flexColumnContainer">
  @if (casesLink) {
    <div class="buttonWithText">
      <button mat-button (click)="navigateTo(casesLink)" (keydown.enter)="navigateTo(casesLink)"
              [ngClass]="{'mat-button-active': isActive(casesLink)}">
        <mat-icon class="material-symbols-outlined"
                  [matBadge]="unassignedCaseCount > 0 ? unassignedCaseCount : null"
                  [matBadgeHidden]="unassignedCaseCount <= 0"
                  matBadgeColor="warn"
                  matBadgePosition="above after"
                  matBadgeSize="medium"
                  [ngClass]="{'mat-symbols-fill': isActive(casesLink)}">folder_open
        </mat-icon>
      </button>
      <span class="label-medium">{{ 'sideNavigation.cases' | translate }}</span>
    </div>
  }
  @if (memberLink) {
    <div class="buttonWithText">
      <button mat-button (click)="navigateTo(memberLink)" (keydown.enter)="navigateTo(memberLink)"
              [ngClass]="{'mat-button-active': isActive(memberLink)}">
        <mat-icon class="material-symbols-outlined" [ngClass]="{'mat-symbols-fill': isActive(memberLink)}">groups
        </mat-icon>
      </button>
      <span class="label-medium">{{ 'sideNavigation.member' | translate }}</span>
    </div>
  }
</div>
